import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcOther = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "22.41 19.28 35.19 37.44",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(16,2) scale(2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "m 12.016,8.64 -1.219,1.688 v 5.438 l -7.594,4.031 v 1.469 l 7.594,-2.531 v 6.031 l -2.781,1.156 v 1.438 l 4,-1.031 4,1.031 v -1.469 l -2.813,-1.125 v -6.031 l 7.594,2.531 V 19.297 L 13.203,15.766 V 11.328 Z",
			stroke: "undefined",
			fill: "undefined"
		})
	})
});
export default SvgIcOther;
